import { useEffect } from 'react';

let isMetaPixelInitialized = false;

const MetaPixel = () => {
  useEffect(() => {
    if (isMetaPixelInitialized) return;

    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script');

    if (typeof window.fbq !== 'undefined') {
      window.fbq('init', process.env.REACT_APP_META_PIXEL_ID);
      window.fbq('track', 'PageView');
      isMetaPixelInitialized = true;
    }
  }, []);

  return (
    <>
      <noscript>
        <div
          dangerouslySetInnerHTML={{
            __html: `<img height="1" width="1" style="display:none"
              src="https://www.facebook.com/tr?id=${process.env.REACT_APP_META_PIXEL_ID}&ev=PageView&noscript=1" />`,
          }}
        />
      </noscript>
    </>
  );
};

// ✅ Event tracking helper
export const trackMetaEvent = (eventName, params = {}) => {
  if (typeof window.fbq !== 'undefined') {
    window.fbq('track', eventName, params);
  } else {
    console.warn(`[Meta Pixel] Event "${eventName}" not fired — fbq not available`);
  }
};

export default MetaPixel;
